import React from 'react';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Video from 'housecall-ui/dist/DesignSystem/DataDisplay/Video/Video';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import SuperproAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/SuperproAppIcon';

import SuperProButton from '../OtherComponents/SuperProButton';

const SuperProStrategy = {
  previewInfo: {
    name: 'SuperPro',
    iconSvg: <SuperproAppIcon size="xlarge" />,
    newTab: true,
  },
  headerInfo: {
    name: 'SuperPro',
    category: 'Community',
    details: (
      <div>
        The Housecall Pro Superpro Program is dedicated to defining excellence and identifying the highest-quality local
        home service companies conquering their industries.
        <br /> <br />
        Superpros utilize Housecall Pro solutions to generate business, offer customers highly-rated service, and
        continually improve themselves and the home service industry through continued education, community activity,
        and helping shape the future of Housecall Pro software.
        <br /> <br />
        Every month, we award this status to Housecall Pros committed to providing their customers with a transparent,
        modern, and digital experience from day one, establishing a strong relationship for years to come.
        <br /> <br />
        Being a Superpro means Pros have met application requirements, honor their Superpro commitments, and share in a
        wealth of benefits.
        <br /> <br />
        <b>What are the requirements to become a Superpro?</b>
        <br /> <br />
        To become a Superpro, you must first:
        <br />
        <ul>
          <li>Be an active Housecall Pro customer on most current plan (i.e. V8)</li>
          <li>Have Account Settings fully set up with your company logo and bio</li>
          <li>Complete on average at least 15 jobs every 30 days</li>
          <li>Have ‘My Money’ set up and able to accept credit cards through Housecall Pro</li>
          <li>Use at least 1: Pipeline, VOIP, Advanced Reporting, Payroll, Expense Cards, and Job Costing</li>
          <li>Have an average 4.8+ star business rating on Google and/or Housecall Pro Reviews</li>
          <li>Be in business for one year or more at the time of submitting your application</li>
          <li>Have a claimed, activated Google My Business page</li>
          <li>Have an active business social presence (Facebook, Instagram, or Tik Tok)</li>
          <li>Have a professional website offering your customers online booking</li>
          <li>Be an active member of Housecall Pros Facebook community and in good standing</li>
          <li>Have agreed to the Superpro Code of Ethics and Commitments</li>
          <li>Have requested to be added to Superpro Facebook group</li>
        </ul>
        <Video src="https://tryhousecall-1.wistia.com/medias/jhmvxlbczq" />
        <br />
        <b>What do Superpros do?</b>
        <br /> <br />
        To retain their recognition and unlock exclusive swag, Superpros:
        <ul>
          <li>Provide a combination of at least 3 per year of the following:</li>
          <ul>
            <li>Housecall Pro referrals from their network </li>
            <li>Post to their social media accounts using the Housecall Pro hashtag #HCPSuperpro </li>
            <li>
              Connect with Housecall Pro customers (potential and existing) to share their Housecall Pro experience
            </li>
          </ul>
          <li>Post or comment at least 3 times per year in the Superpro Facebook community</li>
          <li>Post or comment at least 3 times per year Housecall Pro Facebook community</li>
          <li>
            Post Superpro badges upon receiving them to their social media accounts using the hashtag #HCPSuperpro
          </li>
          <li>Attend product research & review sessions</li>
          <li>
            Attend growth events (i.e. CONQUER bootcamp, #WhiteboardWednesday, #QuickTipTuesday, Office Hours, Industry
            Zoom Meetups, etc.)
          </li>
        </ul>
        <br />
        <b>What benefits do Superpros receive?</b>
        <br /> <br />
        Beyond the business results that come from meeting the Superpro standard, Superpros get a ton of exclusive
        benefits:
        <ul>
          <li>Directly shape the future of the Housecall Pro product and community</li>
          <li>
            Direct and free access to alpha and beta testing and frontline development of all products (core, fintech,
            etc.)
          </li>
          <li>Direct access to the Housecall Pro team</li>
          <li>Access to Priority Chat Support (coming soon)</li>
          <li>Continued growth opportunities:</li>
          <ul>
            <li>#QuickTipTuesday - weekly Facebook Live Event bringing Superpro tips</li>
            <li>
              Office Hours - weekly open-forum webinar exclusive for Superpros to ask questions, share ideas, and get a
              direct response
            </li>
            <li>Free access to CONQUER Bootcamps ($44 value)</li>
            <li>One free monthly CONQUER business resource </li>
            <li>Access to the CONQUER Facebook Growth Vault</li>
          </ul>
          <li>Exclusive access to Superpro community</li>
          <li>Digital Certified Superpro badges for website and social media</li>
          <li>Printed Gold Leaf Superpro Certificate</li>
          <li>Superpro swag - opportunity to unlock tons of exclusive swag</li>
          <li>Free trial on a feature you don&lsquo;t currently have at time of acceptance</li>
          <li>SEO-boost opportunities through content posted on Housecall Pro website</li>
          <li>Exclusive Superpro monthly newsletter with information on features coming your way</li>
          <li>Invite to exclusive Superpro in-person event</li>
        </ul>
      </div>
    ),
    iconSvg: <SuperproAppIcon size="xlarge" />,
  },
  media: {},
  sellingPoints: {},
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    hideToggle: true,
    hideCard: true,
    showBetaButton: false,
    appActionButton: <SuperProButton />,
  },
  supportContacts: [{ type: 'Email', contact: 'superpro@housecallpro.com' }],
};

export default SuperProStrategy;
